import axios from "axios";

export const getJobTypes = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_job_types"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
